
<script setup lang="ts">
import ProductdetailsOtcImage from "@/vue_components/praeparate/produktdetails-otc/productdetails-otc-image/productdetails-otc-image.vue"
import TableArticleList from "@/vue_components/praeparate/shared/table-article-list/table-article-list.vue"
import ProductDocuments from "@/vue_components/praeparate/shared/product-documents/product-documents.vue"
import DropdownPraeparate from "@/vue_components/praeparate/shared/dropdown-praeparate/dropdown-praeparate.vue"
import BestellButton from "@/vue_components/praeparate/shared/bestell-button/bestell-button.vue"
import {useProductDetailsCommon} from "@/api/composables/useProductDetailsCommon";
import {useProductDetailsOtc} from "@/api/composables/useProductDetailsOtc";


interface Props {
  productId: number
  praeparatId: number
  hidePflichttext: boolean
}

const props = defineProps<Props>()

const {
  dictionary,
  praeparat,
  productData,
  isLoading,
  praeparatList,
  docLabel
} = useProductDetailsCommon(props.productId, props.praeparatId)

const { gotoPflichttext } = useProductDetailsOtc(props.productId)

function handlePflichttextClick() {
  if (praeparat.value) {
    gotoPflichttext(praeparat.value.id)
  }
}

</script>

<template>
  <div class="product-details-otc">
    <Loader v-if="isLoading"/>

    <div v-else-if="productData && praeparat" class="productDetailsContainer">
      <div class="product-info" :class="praeparat?.otcKategorie?.id" v-if="dictionary">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 product-img">
              <ProductdetailsOtcImage :praeparat="praeparat" />
            </div>
            <div class="col-12 col-md-6 product-details">
              <div class="praeparat-kategorie-pflichttext">
                <h2 class="praeparat-kategorie" v-if="praeparat.otcKategorie">
                  Kategorie: {{ praeparat.otcKategorie.name }}
                </h2>

                <div v-if="!hidePflichttext">
                  <span v-if="praeparat.wirkstoffInhalt" class="pflichttext" @click="handlePflichttextClick">
                    Pflichttext
                  </span>
                </div>
              </div>

              <h1 class="result-name">{{ praeparat.name }}</h1>
              <p class="praeparat-inhalt"></p>
              <div class="praeparat-indikation" v-if="praeparat.anwendungsgebiet"
                   v-html="praeparat.anwendungsgebiet"></div>

              <TableArticleList :praeparat="praeparat" :dictionary="dictionary" />

              <p class="produkte-label">{{ docLabel }}</p>

              <ProductDocuments :praeparat="praeparat" :dictionary="dictionary" />

              <DropdownPraeparate
                  :productName="productData?.name ?? ''"
                  :selected="praeparat"
                  :praeparatList="praeparatList"
                  :dictionary="dictionary"
                  @select="praeparat = $event"
              />

              <BestellButton :praeparat="praeparat" :dictionary="dictionary" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Component-spezifische Styles */
</style>